import { render, staticRenderFns } from "./LoginsPerWeek.vue?vue&type=template&id=450f21cb"
import script from "./LoginsPerWeek.vue?vue&type=script&lang=js"
export * from "./LoginsPerWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports